import React, { Component, useEffect } from 'react';
import * as firebase from 'firebase';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import '../view/css/ProfileSettings.css';
import { ProfileSettingsSubscriptions } from '../view/ProfileSettingSubscriptions';
import { ProfileSettingsTags } from '../view/ProfileSettingTags';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import { DeleteAccountModal } from '../model/DeleteAccountModal';
import { ContactUsModal2 } from './ContactUsModal2';

export const ProfileSettings = () => {

    const [email, setEmail] = React.useState("");
    //const [notification, setNotification] = React.useState(false);
    const [interests, setInterests] = React.useState([]);
    const [username, setUserName] = React.useState("");
    const [subscriptions, setSubscriptions] = React.useState([]);
    const [password, setPassword] = React.useState("");
    const [profile_pic, setPicture] = React.useState("");
    const [blockedAffiliates, setBlockedAffiliates] = React.useState([]);
    const [type_1, setType] = React.useState("");
    const [userLoaded, setUserLoaded] = React.useState(false);
    // Affiliate only fields
    const [description, setDescription] = React.useState("");
    const [photos, setPhotos] = React.useState([]);
    const [facebook, setFacebook] = React.useState("");
    const [searchText, setSearchText] = React.useState("");
    const [userExist, setUserExist] = React.useState(true);
    const [photosdelete, SetPhotosDelete] = React.useState([]);

    const [editNameBool, setEditNameBool] = React.useState(false);
    const [editEmailBool, setEditEmailBool] = React.useState(false);
    const [editPasswordBool, setEditPasswordBool] = React.useState(false);
    const [editDescriptionBool, setEditDescriptionBool] = React.useState(false);
    const [editInterestsBool, setEditInterestsBool] = React.useState(false);
    const [deleteSubscriptionsBool, setDeleteSubscriptionsBool] = React.useState(false);
    const [deletePhotosBool, setDeletePhotosBool] = React.useState(false);
    const [deleteBlockedAffiliatesBool, setDeleteBlockedAffiliatesBool] = React.useState(false);
    const [addPhotosBool, setAddPhotosBool] = React.useState(true);
    const [photosUpdated, setPhotosUpdated] = React.useState(true);
    const [showProfileSubmit, setShowProfileSubmit] = React.useState(false);
    const [showPhotoSubmit, setShowPhotoSubmit] = React.useState(false);
    const [photos_array,setPhotoArray] = React.useState([]);
    const [photos_profile,setProfilePhoto] = React.useState("");
    const [stopy, setStopy] = React.useState(false);
    const [profile_stopy,setProfileStopy] = React.useState(false);

    // States for handling the tags
    const [tagsGotten, setTagsGotten] = React.useState(false);
    const [allTags, setAllTags] = React.useState([]);
    const [selectedTags, setSelectedTags] = React.useState([]);
    const [existingTagsGotten, setExistingTagsGotten] = React.useState(false);
    const [existingTags, setExistingTags] = React.useState([]);

    const inputFile = React.createRef();
    const [imageAsFile, setImageAsFile] = React.useState(null);
    const [imageAsUrl, setImageAsUrl] = React.useState('');

    const [subscriptionsPrint, setSubscriptionsPrint] = React.useState([]);

   

    var firestore = firebase.firestore();
    var user;
    firebase.auth().onAuthStateChanged(function(users) {
    user = users;
    })
    const storage = firebase.storage();
    useEffect(()=>{
        if(!existingTagsGotten){
            getExistingTags();
        }
        if(!userLoaded){
            runThis();
        }
    })
    const handleSubmit = async (image) => {
        const db = firestore.collection("Users").doc(user.email);
       const prev_profile = await db.get();
       if(prev_profile.exists){
         setProfilePhoto(prev_profile.data().profile_pic);
        
       }
        var url = "";
     
        console.log('start of upload');
        if (image === '') {
            console.log('not an image');
        }
        if(image.name != undefined){
        const check_dup = storage.ref('/images/' + image.name);
        try{
            var this_link = await check_dup.getDownloadURL();
            console.log("storage exists");
          
            db.update({
                "profile_pic" : this_link
            })
            setPicture(this_link);
        }catch(err)  {
            await check_dup.put(image);
            const new_image = await check_dup.getDownloadURL();
            setPicture(new_image);
            db.update({
                'profile_pic': new_image
            })

        }
    }
        
       

    }

    const handlePhotoSubmit = async (image) => {
        const db = firestore.collection("Users").doc(user.email);
         var test_this = [];
         var set_wait = false;
        const getting_photos = await db.get();
        if(getting_photos){
            test_this = getting_photos.data().photos;
        }
         if(getting_photos && !stopy){
             setPhotoArray(getting_photos.data().photos);
             setStopy(true);
         }
        var url = "";
       // e.preventDefault();
        console.log('start of upload');
        if (image === '') {
            console.log('not an image');
        }
        if(image.name != undefined){
        const check_dup = storage.ref('/images/' + image.name);
        if(!check_dup){
            console.log("THIS NO WORK")
        }
        
        try{
            const is_dup = await check_dup.getDownloadURL();
            var copy = [...photos];
          
            console.log(is_dup);
            copy.push(is_dup);
          
            await db.update({
                "photos": copy
            });
            setPhotos(copy);
     
        }catch{
           await check_dup.put(image);
            const new_pic = await check_dup.getDownloadURL();
            var copy = [...photos];
            copy.push(new_pic);
            await db.update({
                "photos": copy
            });
            setPhotos(copy);
   
    }
       
      
           
            

    }
}

    const handleProfileImageAsFile = (e) => {
        const image = e.target.files[0];
        console.log("image is " + image);
        
        handleSubmit(image);
        setShowProfileSubmit(true);
     
    }

    const handlePhotoImageAsFile = (e) => {
        console.log("Clicked browse");
        const image = e.target.files[0];
        setImageAsFile(image);
        handlePhotoSubmit(image);
        setShowPhotoSubmit(true);
     
    }

    const changeEditNameBool = () => {
        setEditNameBool(true);
    }

    const changeEditEmailBool = () => {
        setEditEmailBool(true);
    }
    const changeEditPasswordBool = () => {
        setEditPasswordBool(true);
        console.log(editPasswordBool);
    }

    const changeEditDescriptionBool = () => {
        setEditDescriptionBool(true);
        console.log(editDescriptionBool);
    }

    const changeEditInterestsBool = () => {
        setEditInterestsBool(true);
        console.log(editInterestsBool);
    }

    const changeDeleteSubscriptionsBool = () => {
        setDeleteSubscriptionsBool(true);
    }

    const changeDeletePhotosBool = () => {
        console.log("in delete");
        setDeletePhotosBool(true);
        setAddPhotosBool(false);
    }

    const cancelPhotoDelete = () => {
        setDeletePhotosBool(false);
        setAddPhotosBool(true);
        setPhotosUpdated(true);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "photos": photos
        });
        SetPhotosDelete([]);
    }

    const cancelDelete = () => {
        setDeleteSubscriptionsBool(false);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "subscriptions": subscriptions
        });
    }

    const cancelDeleteBlocked = () => {
        setDeleteBlockedAffiliatesBool(false);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "blocked": blockedAffiliates
        });
    }

    const confirmChangePhotos = () => {
        setAddPhotosBool(false);
        setShowPhotoSubmit(false);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "photos": photos
        });
        setStopy(true);
        setPhotoArray([]);
    }

    const confirmSubDelete = () => {
        setDeleteSubscriptionsBool(false);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "subscriptions": subscriptions
        });
    }



    /* Functions dealing with tags */
    const getTags =  () => {
        // This retrieves the fulle list of tags from the database
        const db = firestore.collection("Tag");
        var tags = [];
        db.get().then((data) => {
            data.forEach((doc) => {
                //add each doc.id into tags
                var tagName = doc.data().name; //let tags = tags.push(doc.id)
                //console.log(tagName);
                tags.push(tagName);
                //console.log(tags);
            });
        });
        setTagsGotten(true);
        setAllTags(tags);
        console.log("All the tags: " + allTags);
        //listTags();
    }

    const getExistingTags = async () => {
        //Retrieve existing user tags here too
        // Hard code the email for now
        if (user) {
            console.log("Logged in");
            const db = firestore.collection("Users").doc(user.email);
           
           
          /* const doc = db.get().then(function (doc) {
                if (doc.exists) {
                    setSelectedTags(doc.data().interests);
                    console.log("Existing interests for Bobby: " + doc.data().interests);
                }
            });*/
            const we_wait = await db.get();
            if(we_wait.exists){
                setSelectedTags(we_wait.data().interests);
            }
            console.log("Existing tags: " + existingTags);
            //setSelectedTags(existingTags);
            setExistingTagsGotten(true);
        }


    }

    const handleCheck = (e) => {
        console.log("name = " + e.target.id);
        console.log(e);
        if (selectedTags.includes(e.target.id)) {
            var copy = [...selectedTags];
            var index = copy.indexOf(e.target.id);
            if (index !== -1) {
                copy.splice(index, 1);
                setSelectedTags(copy);
            }
        } else {
            var copy = [...selectedTags];
            copy.push(e.target.id);
            setSelectedTags(copy);

        }

        console.log("Selected tags = " + selectedTags);
    }

    const deleteSubscription = (e) => {
        console.log("Sub name: " + e);
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "subscriptions": firebase.firestore.FieldValue.arrayRemove(e)
        });
    }

    const changeField = async () => {
        var firestore = firebase.firestore();
        const db = firestore.collection("Users").doc(user.email);
         await db.update({
            "interests": selectedTags
        });

        cancelChange();

    }

    /* End of functions dealing with tags */

    const logout = () => {
        firebase.auth().signOut();
        console.log("YOU ARE LOOPING LOGOUT");
    }

    const changeName = () => {
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "username": searchText,
        });
        setUserLoaded(false);
    }


    const changeEmail = () => {
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "email": searchText,
        });
        setUserLoaded(false);

    }

    const changePassword = () => {
        const db = firestore.collection("Users").doc(user.email);
        db.update({
            "password": searchText,
        });
        setUserLoaded(false);
    }

    const changeDescription = async () => {
        const db = firestore.collection("Users").doc(user.email);
       await db.update({
            "description": searchText,
        });
        setDescription(searchText);
        setUserLoaded(false);
    }

    const cancelChange = () => {
        setUserLoaded(false);
    }

    const cancelPhotoChange = async () => {
        setImageAsFile(null);
    
      
     
        console.log("OOGABOOGA");
        console.log(photos_array.length);
     
            await firestore.collection("Users").doc(user.email).update({
                photos: photos_array
            })
        
    
        const db = firestore.collection("Users").doc(user.email);
        const photos_ar = await db.get();
        if(photos_ar.exists){
            const pa = photos_ar.data().photos;
            setPhotos(pa);
        }
        setStopy(false);
        setShowPhotoSubmit(false);
        setPhotoArray([]);
       


    }
    const cancel_photo_profile = async () => {
        if(photos_profile.length != undefined){
            await firestore.collection("Users").doc(user.email).update({
                profile_pic: photos_profile
            })
        }
        const new_profile = await  firestore.collection("Users").doc(user.email).get();
        if(new_profile.exists){
            const old_profile = new_profile.data().profile_pic;
            setShowProfileSubmit(false);
            setProfilePhoto("");
            setPicture(old_profile)
        }
      
  
    }
   
    const cancelingPhotoDelete = async () =>{
       const db = firestore.collection("Users").doc(user.email);
      
        if(photosdelete.length != undefined){
        console.log(photosdelete.length);
       
        for( var i =0; i<photosdelete.length;i++){
        console.log(photosdelete[i]);
        const this_one = photosdelete[i];
       
      await db.update({
            "photos": firebase.firestore.FieldValue.arrayUnion(...this_one)
        });
        }
        
       
       

       
    }
    console.log('i exit here')
    const this_one = await db.get();
    if(this_one.exists){
    console.log(this_one.data().photos);
    setPhotos(this_one.data().photos);
    }
    
    setDeletePhotosBool(false);
    
    SetPhotosDelete([]);
    }

    const handleText = (e) => {
        e.preventDefault();
        //Store search input as a state
        setSearchText(e.target.value);
    }
    const confirmProfileChange = () =>{
        setProfilePhoto("");
        setShowProfileSubmit(false);
    }
    const runThis = async () => {
        if (user) {

            console.log("THIS USER EXISTS: " + user.email)
            const db = firestore.collection("Users").doc(user.email);
            const doc = await db.get();
                if (doc.exists) {
                    
                    //console.log("Document data: ", doc.data().notification);
                    setEmail(doc.data().email);
                    //setNotification(doc.data().notification);
                    setPassword(doc.data().password);
                    setSubscriptions(doc.data().subscriptions);
                    setInterests(doc.data().interests);
                    setUserName(doc.data().username);
                    console.log("Username: " + doc.data().username);
                    setPicture(doc.data().profile_pic);
                    setType(doc.data().type);
                    setPhotos(doc.data().photos);
                    setUserLoaded(true);
                    console.log("User loaded: " + userLoaded);
                    setEditNameBool(false);
                    setEditEmailBool(false);
                    setEditPasswordBool(false);
                    setEditInterestsBool(false);
                    setDeleteSubscriptionsBool(false);
                    setTagsGotten(false);
                    setExistingTagsGotten(false);
                    setDeletePhotosBool(false);
                    setAddPhotosBool(true);
                    setShowPhotoSubmit(false);
                    setShowProfileSubmit(false);
                    setSelectedTags([]);
                    setImageAsFile(null);
                    console.log(doc.data().username);
                    console.log("YOU ARE LOOPING 1");
                    if (doc.data().type=== "Affiliate") {
                        setDescription(doc.data().description);
                        setFacebook(doc.data().facebook);
                        setEditDescriptionBool(false);
                    }
                    if (doc.data().type === "Student") {
                        setBlockedAffiliates(doc.data().blocked);

                    }

                } else {
                    console.log("NOTHING EXISTS");
                }

         


            if (subscriptions !== undefined ) {
                subscriptions.map((sub) => (
                
                firestore.collection("Users").doc(sub).get().then(function (doc) {
                    if(!subscriptionsPrint.includes(doc.data().username)) {
                        setSubscriptionsPrint([...subscriptionsPrint, doc.data().username])
                    }
                }

                )));
            }
            
        }
    }



    return (
        <div className="ProfileSettings">
            {/*!userLoaded && runThis()*/}
            {!tagsGotten && getTags()}
            {/*!existingTagsGotten && getExistingTags()*/}
            <div className="NavBar">
                {type_1 == "" ? <NavBarGuest /> : type_1 == "Student" ? <NavBarUser /> : <NavBarAffiliate />}
            </div>

            <div className="MainPage">
                <div className="SettingsSaveCancel">
                    <div className="Title">
                        {type_1 === "Affiliate" ? <h1> Affiliate Account Settings </h1> : <h1> Student Account Settings </h1>}
                    </div>
                    <div className="SaveCancelButtons">
                        <button className="LogoutButton" onClick={logout}><Link style={{ textDecoration: 'none', color: "inherit" }} to="/">Logout</Link></button>
                        <div className="ProfileContactUs">
                            <ContactUsModal2 /> 
                        </div>
                    </div>
                </div>

                <div className="ImageAndInformation">
                    <div className="ImageAndUploadButton">
                        <div className="ProfilePicture">
                            <img src={profile_pic} className="StudentPicture" />
                        </div>

                        <label className="UploadNewProfilePhotoButton" for="profile-upload"> Change Profile Picture <input className="FileChooser" type='file' id='profile-upload' onChange={handleProfileImageAsFile} accept='image/*' /></label>
                        <div className="ProfileButtonContainer">
                            {showProfileSubmit && <button className="ProfileButton" onClick={confirmProfileChange}> Submit </button>}
                            {showProfileSubmit && <button className="ProfileButton" onClick={cancel_photo_profile}> Cancel </button>}
                        </div>
                    </div>
                    <div className="AccountInfo">

                        <div className="AccountField">
                            <button className="EditFieldButton" onClick={changeEditNameBool}>Edit</button><h3> Username: </h3> <p className="AccountValue">{username}</p> 
                        </div>
                        {editNameBool && <div class="HiddenEdit"><input type="text" name="name" placeholder="Change name" onChange={handleText} />
                            <button className="ConfirmFieldChangeButton" onClick={changeName}>Confirm</button> <button className="CancelFieldChangeButton" onClick={cancelChange}>Cancel</button></div>}

                        <div className="AccountField">
                            <h3 className="Email"> Email: </h3> <p className="AccountValue">{email}</p>
                        </div>


                        <div className="AccountField">
                            <button className="EditFieldButton" onClick={changeEditPasswordBool}> Edit</button><h3> Password: </h3>  <p className="AccountValue">{password} </p> 
                        </div>
                        {editPasswordBool && <div class="HiddenEdit"><input type="text" name="name" placeholder="Change password" onChange={handleText} />
                            <button className="ConfirmFieldChangeButton" onClick={changePassword}>Confirm</button> <button className="CancelFieldChangeButton" onClick={cancelChange}>Cancel</button></div>}



                        {type_1 === "Affiliate" ?
                            <div className="Description">
                                <button className="EditFieldButton" onClick={changeEditDescriptionBool}> Edit</button><h3> Description: </h3>  <p className="AccountValue">{description} </p> 
                            </div> : <div></div>}
                        {editDescriptionBool && <div class="HiddenEdit"><textarea type="text" name="name" onChange={handleText} />
                            <button className="ConfirmFieldChangeButton" onClick={changeDescription}>Confirm</button> <button className="CancelFieldChangeButton" onClick={cancelChange}>Cancel</button></div>}



                        <div className="Tags">
                            <div className="TagsDisplay">
                                {!editInterestsBool && <button className="EditFieldButton" onClick={changeEditInterestsBool}>Edit</button>}
                                <h3 >Tags:</h3>
                                <div className="TagsContainer">
                                    {interests.map((interests) => (
                                        <div className="InterestWrapper"><p className="InterestLabels">{interests}</p></div>
                                    ))}
                                </div>
                                
                                {interests.length == 0 && type_1 == "Student" && <p> You currently have no tags, click edit to add tags! </p>}
                                {interests.length == 0 && type_1 == "Affiliate" && <p> Add tags to help students find your page! </p>}
                                {/* {!editInterestsBool && <button className="EditFieldButton" onClick={changeEditInterestsBool}>Edit</button>} */}
                            </div>
                            
                            <div className="TagsEdit">
                                {editInterestsBool &&
                                    <div class="TagsHiddenEdit">
                                        {allTags.map((name) => (
                                            <div className="TagLister">
                                                {name != undefined ? selectedTags.includes(name) ?
                                                    <div class="Tag">
                                                        <input className="Checkbox" type="checkbox" id={name} name={name} value={true} onChange={handleCheck} checked />
                                                        <p className="TagName">{name}</p>
                                                    </div>
                                                    :
                                                    <div class="Tag">
                                                        <input className="Checkbox" type="checkbox" id={name} name={name} value={false} onChange={handleCheck} />
                                                        <p className="TagName">{name}</p>
                                                    </div>
                                                    :
                                                    <div></div>
                                                }
                                            </div>
                                        ))}

                                        
                                    </div>
                                }
                            </div>
                            {editInterestsBool && <div className="TagButtons">
                                <button className="TagChange" onClick={changeField}>Confirm</button> <button className="TagChange" onClick={cancelChange}>Cancel</button>
                            </div>}

                        </div>

                        <div className="PhotosWrapper">
                            {type_1 === "Affiliate" && 
                                photos.map((photo) => (
                                    <div className="PhotoComponent">
                                        <img className="AffiliatePhoto" src={photo} />
                                        {deletePhotosBool && <button className="DeletePhoto" onClick={() => {
                                            const db = firestore.collection("Users").doc(user.email);
                                            var copy = [...photos];
                                            var this_one = [...photos];
                                            console.log(copy);
                                            SetPhotosDelete([...photosdelete, this_one]);
                                            var index = copy.indexOf(photo);
                                            if (index !== -1) {
                                                copy.splice(index, 1);
                                                setPhotos(copy);
                                            }
                                            console.log(copy.length);
                                            db.update({
                                                "photos": photos
                                            });
                                            console.log("I DELETE HEHE")
                                            if (photos.length == 0) {
                                                setPhotosUpdated(false);
                                            }
                                        }}>X</button>}
                                    </div>

                                )) 
                            }
                        </div>
                          {type_1 == "Affiliate" ?
                            !deletePhotosBool && photos.length == 0 ?
                                <div className="NoPhotos">
                                    
                                   {/* <button onClick={() => console.log("test button clicked")}>test</button>*/}
                                    <label className="UploadPhotoButton" for="photo-upload">Browse <input type='file' id='photo-upload' onChange={handlePhotoImageAsFile} accept='image/*' /></label>
                                    {/*showPhotoSubmit && <button className="PhotoChangeButton" onClick={handlePhotoSubmit}> Add </button>*/}
                                </div>
                                :
                                !deletePhotosBool ?  
                                    <div className="EditPhoto">
                                        <button className="DeletePhotoButton" onClick={changeDeletePhotosBool}>Edit</button>
                                        <label className="UploadPhotoButton" for="photo-upload"> Browse <input type='file' id='photo-upload' onChange={handlePhotoImageAsFile} accept='image/*' /></label>
                                        {/*showPhotoSubmit && <button className="PhotoChangeButton" onClick={handlePhotoSubmit}> Add </button>*/}
                                        {showPhotoSubmit && <button className="PhotoChangeButton" onClick={confirmChangePhotos}> Confirm </button>}
                                        {showPhotoSubmit && <button className="PhotoChangeButton" onClick={cancelPhotoChange}> Cancel </button>}
                                    </div>
                                    :
                                    <div>
                                        <button className="CancelDeletePhotosButton" onClick={cancelingPhotoDelete}>Cancel</button>
                                        <button className="CancelDeletePhotosButton" onClick={cancelPhotoDelete} >Confirm Delete</button>
                                    </div>

                            :
                            <p className="Hidden"></p>}

                        <div className="SubscriptionsField">
                            {type_1 === "Student" &&
                                <div className="Subscriptions">
                                    <h3 className="SubscriptionsTitle">Subscriptions:</h3>
                                    {subscriptions.map((subscription) => (
                                        <div className="SubscriptionLabels">
                                            <p>{subscription}</p>
                                            {deleteSubscriptionsBool && <button class="DeleteSub" onClick={() => {
                                                const db = firestore.collection("Users").doc(user.email);
                                                var copy = [...subscriptions];
                                                var index = copy.indexOf(subscription);
                                                if (index !== -1) {
                                                    copy.splice(index, 1);
                                                    setSubscriptions(copy);
                                                }
                                                db.update({
                                                    "subscriptions": subscriptions
                                                });

                                                const subscribersRef = firestore.collection("Users").doc(subscription);
                                                subscribersRef.update({
                                                    students: firebase.firestore.FieldValue.arrayRemove(user.email)
                                                })
                                            }}>X</button>}
                                        </div>
                                    ))}
                                </div>
                            }
                            {type_1 == "Student" ?
                                !deleteSubscriptionsBool && subscriptions.length == 0 ?
                                    <p>You are currently not subscribed to any affiliates. Discover affiliates in our Explore Page!</p> :
                                    !deleteSubscriptionsBool ?
                                        <button className="DeleteSubscriptionButton" onClick={changeDeleteSubscriptionsBool}>Edit</button> :
                                        <div><button className="ConfirmDelete" onClick={confirmSubDelete}>Confirm Delete</button></div> :
                                <p></p>}
                        </div>

                        {/* <div className="BlockedAffiliateField">
                            {type_1 === "Student" &&
                                <div className="BlockedAffiliates">
                                    <h3 className="BlockedAffiliatesTitle">Blocked Affiliates:</h3>
                                    {blockedAffiliates.map((blocked) => (
                                        <div className="BlockedLabels">
                                            <p>{blocked}</p>
                                            {deleteBlockedAffiliatesBool && <button onClick={() => {
                                                const db = firestore.collection("Users").doc(user.email);
                                                var copy = [...blockedAffiliates];
                                                var index = copy.indexOf(blocked);
                                                if (index !== -1) {
                                                    copy.splice(index, 1);
                                                    setBlockedAffiliates(copy);
                                                }
                                                db.update({
                                                    "blocked": blockedAffiliates
                                                });
                                            }}>X</button>}
                                        </div>
                                    ))}
                                </div>
                            }
                            {type_1 == "Student" ? !deleteBlockedAffiliatesBool && blockedAffiliates.length == 0 ? <p>You have not currently blocked any affiliates</p> : !deleteBlockedAffiliatesBool ? <button className="DeleteBlockedAffiliatesButton" onClick={() => { setDeleteBlockedAffiliatesBool(true) }}>Edit</button> : <div><button className="CancelDeleteSubs" onClick={cancelDeleteBlocked}>Cancel</button><button className="ConfirmDeleteBlocked" onClick={cancelDeleteBlocked}>Confirm Delete</button></div> : <p></p>}
                        </div> */}


                        <div className="DeleteAccount">
                            <DeleteAccountModal password={password} type={type_1} email={email}/>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
}
